/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { DataContextProvider } from '@forge/data-connector';
import React from 'react';
import { ContextProvider, updateApiConfig } from '../../context/ApiContext';
import IEnergyManagementProps from '../DashboardKPIWidgets/IEnergyManagementProps';
import EnergyOptimizationSettingsComponent from './EnergyOptimizationSettingsComponent';
import { withLocalization } from '../../locales/withLocalization';

const EnergyOptimizationSettingsWidget = (props: IEnergyManagementProps) => {
  const { connectorConfig, bearerToken, requestContext, emaasContext } = props;
  return (
    <ContextProvider
      value={updateApiConfig({
        connectorConfig,
        ...emaasContext
      })}
    >
      <DataContextProvider config={connectorConfig}>
        <EnergyOptimizationSettingsComponent
          requestContext={requestContext}
          bearerToken={bearerToken}
          connectorConfig={connectorConfig}
        />
      </DataContextProvider>
    </ContextProvider>
  );
};

export default withLocalization<IEnergyManagementProps>(
  EnergyOptimizationSettingsWidget
);
